import { oneOfType, arrayOf, node, func } from 'prop-types';

/**
 * A valid, renderable node.
 */
export const RENDERABLE = oneOfType([
    arrayOf(node),
    node,
    func
]);
